import {
  AddViewAction,
  DeleteStoryAction,
  DeleteStoryFromStoreAction,
  GetStoriesAction,
  LoadViewsAction,
  ReadOneAction,
  SetCurrentStoryIdAction,
  SetLoadingAction,
  SetLoadingViewsAction,
  SetStoriesAction,
  SetViewAction,
  SetViewsLoadingFailedAction,
  SetViewsTotalAction,
  StoriesState,
  UploadStoryAction,
} from './interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '$store/rootReducer';
import { StoriesGroup } from '$store/models';

const initialState: StoriesState = {
  isLoading: false,
  sound: localStorage.getItem('storySound') !== 'false',
  stories: [],
  currentStoryId: null,
  views: [],
  viewsTotal: 0,
  viewsNextFrom: '',
  viewsLoadingFailed: false,
  isLoadingViews: true,
};

export const sortStories = (stories: StoriesGroup[]) => {
  return stories
    .map((group) => ({
      ...group,
      stories: group.stories.sort((a, b) => {
        return a.createdAt - b.createdAt;
      }),
    }))
    .sort((a, b) => {
      return (
        b.stories.filter((story) => story.unread).length -
        a.stories.filter((story) => story.unread).length
      );
    });
};

export const { actions, reducer } = createSlice({
  name: 'paid',
  initialState,
  reducers: {
    loadViews(_, action: LoadViewsAction) {},
    setLoadingViews(state, action: SetLoadingViewsAction) {
      state.isLoadingViews = action.payload;
    },
    setViewsLoadingFailed(state, action: SetViewsLoadingFailedAction) {
      state.viewsLoadingFailed = action.payload;
    },
    setViewsTotal(state, action: SetViewsTotalAction) {
      state.viewsTotal = action.payload;
    },
    clearViews(state) {
      state.views = [];
      state.viewsNextFrom = '';
      state.viewsTotal = 0;
      state.isLoadingViews = true;
      state.viewsLoadingFailed = false;
    },
    setLoading(state, action: SetLoadingAction) {
      state.isLoading = action.payload;
    },
    setViews(state, action: SetViewAction) {
      state.views = action.payload;
    },
    addViews(state, action: AddViewAction) {
      state.views = [...state.views, ...action.payload.views];
      state.viewsNextFrom = action.payload.nextFrom;
    },
    deleteStoryFromStore(store, action: DeleteStoryFromStoreAction) {
      store.stories = sortStories(
        store.stories
          .map((group) => ({
            ...group,
            stories: group.stories.filter((story) => story.id !== action.payload),
          }))
          .filter((g) => g.stories.length > 0),
      );
    },
    deleteStory(_, action: DeleteStoryAction) {},
    readOne(state, action: ReadOneAction) {
      state.stories = state.stories.map((user) => {
        return {
          ...user,
          stories: user.stories.map((s) =>
            s.id === action.payload.storyId
              ? {
                  ...s,
                  unread: false,
                }
              : s,
          ),
        };
      });
    },
    uploadStory(_, action: UploadStoryAction) {},
    getStories(state, action: GetStoriesAction) {},
    setStories(state, action: SetStoriesAction) {
      state.stories = sortStories(action.payload);
    },
    setCurrentStoryId(state, action: SetCurrentStoryIdAction) {
      state.currentStoryId = action.payload;
    },
    toggleSound(state) {
      const value = !state.sound;
      localStorage.setItem('storySound', value.toString());
      state.sound = !state.sound;
    },
  },
});

export { reducer as storiesReducer, actions as storiesActions };

export const storiesSelector = (state: RootState) => state.stories;
export const storiesSoundSelector = (state: RootState) => state.stories.sound;
export const storiesCurrentStorySelector = (state: RootState) => {
  const { currentStoryId } = state.stories;
  if (!currentStoryId) {
    return null;
  }
  const [userId, storyId] = currentStoryId;
  return (
    state.stories.stories
      .find((s) => s.userId === userId)
      ?.stories.find((s) => s.id === storyId) || null
  );
};
